import reactContainerFactory from '@/components/react-container/reactContainerFactory';
import { lazy } from 'react';

const cycleCountPool = {
  path: 'ccpool',
  name: 'inventoryManagement.cyclecountpool',
  meta: {
    title: 'Cycle Count Pool',
  },
  redirect: '/inventorymanage/ccpool/ccgroup',
  component: () => import('@/views/layout/subPage.vue'),
  children: [
    {
      path: 'ccgroup',
      name: 'inventoryManagement.cyclecountpool.cyclecountgroup',
      meta: {
        title: 'Cycle Count Group',
      },
      component: reactContainerFactory({
        name: 'inventoryManagement.cyclecountpool.cyclecountgroup',
      }),
      props: {
        component: (): React.ComponentType =>
          lazy(
            () =>
              import(
                '@/react-app/pages/inventory-management/cycle-count-pool/cycle-count-group'
              )
          ),
      },
    },
    {
      path: 'demandpool',
      name: 'inventoryManagement.cyclecountpool.demandpool',
      meta: {
        title: 'Demand Pool',
      },
      redirect: '/inventorymanage/ccpool/demandpool/demanddashboard',
      children: [
        {
          path: 'demanddashboard',
          meta: {
            title: 'Demand Dashboard',
            menuHide: true,
            name: 'demanddashboard',
          },
        },
        {
          path: 'demandmanagement',
          meta: {
            title: 'Demand Management',
            menuHide: true,
            name: 'demandmanagement',
          },
        },
        {
          path: 'operationconfig',
          meta: {
            title: 'Operation Config',
            menuHide: true,
            name: 'operationconfig',
          },
        },
      ],
      component: reactContainerFactory({
        name: 'ruleCenter.boxingrule',
      }),
      props: {
        component: (): React.ComponentType =>
          lazy(
            () =>
              import(
                '@/react-app/pages/inventory-management/cycle-count-pool/demand-pool'
              )
          ),
      },
    },
  ],
};

export default cycleCountPool;
